<ng-container *transloco="let t">
  @if (showEnvironmentBanner) {
    <div class="environment-banner" role="status" aria-live="polite">
      {{ t('portal.environment.testingBanner') }}
    </div>
  }

  <!-- Mobile hamburger button -->
  <button
    class="hamburger-btn"
    [class.hamburger-hidden]="sidebarOpen()"
    (click)="toggleSidebar()"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </svg>
  </button>

  <!-- Mobile backdrop -->
  @if (sidebarOpen()) {
    <div
      class="sidebar-backdrop"
      (click)="closeSidebar()"
      role="button"
      tabindex="0"
      (keydown.enter)="closeSidebar()"
      (keydown.space)="closeSidebar()"
    ></div>
  }

  <!-- Fixed Sidebar: stays fixed on the left side -->
  <div
    class="fixed inset-y-0 left-0 w-72 flex flex-col bg-primary-color z-50 pt-4 pb-4 pl-4 sidebar"
    [class.sidebar-open]="sidebarOpen()"
  >
    <div class="flex min-h-0 flex-1 flex-col primary-color border-radius">
      <div
        class="flex flex-1 flex-col overflow-y-auto pt-5 pb-2 sidebar-scroll min-h-0"
      >
        <div
          class="flex flex-shrink-0 items-center px-4 logo-wrapper sidebar-logo-row"
        >
          <!-- inlined SVG to avoid network fetch and improve LCP -->
          <svg
            class="h-8 w-auto icon big-logo"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 743.27 251.25"
            width="145"
            height="45"
          >
            <defs>
              <style>
                .cls-1 {
                  fill: #fff;
                }
              </style>
            </defs>
            <g id="Layer_2" data-name="Layer 2">
              <g id="Layer_1-2" data-name="Layer 1">
                <path
                  class="cls-1"
                  d="M67.63,87.5A5.4,5.4,0,1,0,73,92.89,5.39,5.39,0,0,0,67.63,87.5Z"
                />
                <path
                  class="cls-1"
                  d="M180.05,102.42c3-2.12,7.49-3.4,11.89,2.58a2.5,2.5,0,0,0,4-3c-6.07-8.26-13.7-7.32-18.82-3.7-6.7,4.76-4.41,13.09-4.31,13.44a2.51,2.51,0,0,0,2.41,1.81,2.84,2.84,0,0,0,.69-.09,2.51,2.51,0,0,0,1.71-3.1C177.64,110.35,176.2,105.15,180.05,102.42Z"
                />
                <path
                  class="cls-1"
                  d="M240.26,5.24C219.85-2.29,195.6-1.5,177.65,6.3A9,9,0,0,0,170.3,7l-9.59,5.54a9,9,0,0,0-3.3,12.33l.57,1a9,9,0,0,0,12.33,3.3l9.59-5.54a9,9,0,0,0,4.39-9.3c14.13-5.38,33.59-6.73,52.51.25,25.4,9.36,41.69,31.49,45.88,62.31,4.8,35.3-24.05,73.06-52.24,100.76a45.8,45.8,0,0,0-2.87-15.37c-6.23-17.52,9.73-34.65,13.52-38.39a34,34,0,0,0,6-2.36,29,29,0,0,0,14.29-34.35L256.15,69.7a15.1,15.1,0,0,0-14.56-10.83h-8a24.71,24.71,0,0,0-10.85,2.52l-11.58,5.7a48.55,48.55,0,0,1-30.09,4.25L168,69a49.49,49.49,0,0,0-18.24.13c-7.7-17.53-23-33-52.12-37.61a7.23,7.23,0,0,0-8.13,8.9l.1.36,3.55,8.46a9.5,9.5,0,0,1-2.57,11,12.22,12.22,0,0,1-5,2.57L70,65.35l-.18,0A20.91,20.91,0,0,0,56.75,74,54.44,54.44,0,0,1,45.46,86,96.66,96.66,0,0,1,27.07,96.8a5.71,5.71,0,0,0-3.47,5.28c0,4,1.14,39.66,36.9,47,6.16,1.26,10.49,4.18,13.24,8.92,5.73,9.9,3.37,25.33,1.23,34.3C57.52,175.81,8.21,125,10.05,78.77,11.07,53,24.9,30.58,47,18.82c18.13-9.63,39.42-10.65,59.39-3.34a9,9,0,0,0,4.51,8.19l9.59,5.54a9,9,0,0,0,12.33-3.3l.58-1a9,9,0,0,0-3.31-12.33L120.54,7a9,9,0,0,0-8.66-.2C88.7-2.27,63.65-1.32,42.35,10,17,23.44,1.22,49,.06,78.38-2.23,136,65.91,197.8,73.69,204.67a5.51,5.51,0,0,0,8.87-2.41c1.72-5.21,9.81-32.07-.17-49.29-4.2-7.26-10.89-11.87-19.88-13.71-24.16-4.94-28.18-26-28.8-34.51A105.89,105.89,0,0,0,51.49,94,63.94,63.94,0,0,0,65,79.69a11,11,0,0,1,6.79-4.49l15.47-2.52.19,0A22,22,0,0,0,96.88,68a19.57,19.57,0,0,0,5.45-22.62l-1.27-3c20.69,4.6,32.48,16,38.92,29.44-14.2,4.88-33,15.69-40.24,39.41a43.6,43.6,0,0,0,.65,27.38c3.85,10.67,9.37,17.3,16.4,19.71,6,2,12.58.84,19.56-3.59A43.43,43.43,0,0,0,156,122.8c1.23-10.61,1.91-27.58-2.87-44.12a39.71,39.71,0,0,1,13,.16l13.14,2.34a58.4,58.4,0,0,0,36.25-5.12l11.58-5.7a14.58,14.58,0,0,1,3.35-1.15,9.42,9.42,0,0,0-.08,1.2c0,5.75,5.2,10.41,11.61,10.41a12.55,12.55,0,0,0,6.47-1.76l3.31,11a19,19,0,0,1-9.26,22.56c-10.23,5.22-21.49,1.26-21.61,1.22a5,5,0,0,0-3.45,9.38,38.79,38.79,0,0,0,9.3,1.93c-6.83,9.25-14.43,24.24-8.66,40.48,4.82,13.55.82,21.69-2.09,25.41-32.12,28.46-63.12,47-69.95,49.86-5.56-2.88-25.37-15.19-44.53-27.41,18.33-14.23,30.47-37.91,31-39a5,5,0,0,0-8.92-4.52c-.14.28-14.22,27.69-33.48,39.25a5.17,5.17,0,0,0-.14,8.79c11.25,7.22,48.37,30.92,53.82,32.87a4.64,4.64,0,0,0,1.74.35c2.39,0,7.33-1.75,21.94-11a440.77,440.77,0,0,0,40.61-29.38c3.55-2.88,7.33-6,11.25-9.45l.14.2a22.6,22.6,0,0,0,3.73-3.6c33.76-30.07,75.44-77.18,69.29-122.43C287.88,40.92,269.29,15.94,240.26,5.24ZM146.08,121.65A33.42,33.42,0,0,1,131,146.27c-4.29,2.72-8,3.59-11,2.57-3.91-1.34-7.54-6.18-10.23-13.65a33.55,33.55,0,0,1-.5-21.06c5.87-19.24,20.8-28.52,34.24-33C147.72,95.16,147.41,110.2,146.08,121.65Z"
                />
                <path
                  class="cls-1"
                  d="M387,75.84q-2.52-6.24-8.93-5.9a8.31,8.31,0,0,0-5.31,1.52,10.09,10.09,0,0,0-3.62,4.38l-37.25,99.27a9.57,9.57,0,0,0,1,8.51c1.68,2.76,4.47,4.13,8.34,4.13s6.6-2,8.18-5.9l8.26-21.91h41l8.26,21.91q2.19,5.91,8,5.9t8.34-4.13a9.6,9.6,0,0,0,1-8.51ZM364.39,141.4,378,105.17l13.65,36.23Z"
                />
                <path
                  class="cls-1"
                  d="M467.87,103.48A32.8,32.8,0,0,0,450,108.7a9,9,0,0,0-17.19,3.71v66.41a8.91,8.91,0,0,0,8.84,8.93,9.37,9.37,0,0,0,6.49-2.61,8.25,8.25,0,0,0,2.87-6.32V138.54a16.54,16.54,0,0,1,4.89-12,16.2,16.2,0,0,1,12-5,17.07,17.07,0,0,1,12.3,5,16.12,16.12,0,0,1,5.14,12v40.28a8.47,8.47,0,0,0,2.7,6.32,8.78,8.78,0,0,0,6.32,2.61,8.25,8.25,0,0,0,6.15-2.61,8.74,8.74,0,0,0,2.53-6.32V138.54a35.25,35.25,0,0,0-35.23-35.06Z"
                />
                <path
                  class="cls-1"
                  d="M532.76,103.65a8.81,8.81,0,0,0-6.49,2.61,9,9,0,0,0-2.61,6.66v65.73a8.76,8.76,0,0,0,2.7,6.41,8.86,8.86,0,0,0,6.49,2.69,8.71,8.71,0,0,0,6.4-2.61,8.81,8.81,0,0,0,2.61-6.49V112.92a9,9,0,0,0-2.61-6.66A8.82,8.82,0,0,0,532.76,103.65Z"
                />
                <path
                  class="cls-1"
                  d="M532.85,69.77a9.22,9.22,0,0,0-9.19,9.1v3.54a9,9,0,0,0,2.7,6.58,8.86,8.86,0,0,0,6.49,2.69,8.59,8.59,0,0,0,6.4-2.69,9.11,9.11,0,0,0,2.61-6.58V78.87a8.84,8.84,0,0,0-2.61-6.49A8.71,8.71,0,0,0,532.85,69.77Z"
                />
                <path
                  class="cls-1"
                  d="M595,103.48a38.54,38.54,0,0,0-18,4.89V79a8.83,8.83,0,0,0-2.78-6.57,9.24,9.24,0,0,0-6.66-2.7A9.22,9.22,0,0,0,558.21,79v99.44a8.83,8.83,0,0,0,2.78,6.58,9.38,9.38,0,0,0,13.15,0,8.83,8.83,0,0,0,2.78-6.58V140.39a18.12,18.12,0,0,1,5.39-12.72A17.67,17.67,0,0,1,595,122.19a18.16,18.16,0,0,1,12.9,5.48,17.35,17.35,0,0,1,5.31,12.72v38.09a9.27,9.27,0,1,0,18.53,0V140.39a35.67,35.67,0,0,0-10.78-26A35.23,35.23,0,0,0,595,103.48Z"
                />
                <path
                  class="cls-1"
                  d="M658.24,69.77a8.84,8.84,0,0,0-6.49,2.7,8.74,8.74,0,0,0-2.7,6.4v3.54a9.2,9.2,0,0,0,9.19,9.27,8.58,8.58,0,0,0,6.4-2.69,9.12,9.12,0,0,0,2.62-6.58V78.87a8.85,8.85,0,0,0-2.62-6.49A8.7,8.7,0,0,0,658.24,69.77Z"
                />
                <path
                  class="cls-1"
                  d="M658.15,103.65a8.8,8.8,0,0,0-6.48,2.61,9,9,0,0,0-2.62,6.66v65.73a8.76,8.76,0,0,0,2.7,6.41,8.87,8.87,0,0,0,6.49,2.69,8.7,8.7,0,0,0,6.4-2.61,8.81,8.81,0,0,0,2.62-6.49V112.92a9,9,0,0,0-2.62-6.66A8.81,8.81,0,0,0,658.15,103.65Z"
                />
                <path
                  class="cls-1"
                  d="M739.73,149.83a23.75,23.75,0,0,0-11-9.27,71.4,71.4,0,0,0-16.35-5.06h-.16l-.17-.16c-5.73-1-9.84-2.36-12.31-4.05a5.55,5.55,0,0,1-1.77-1.52,4.06,4.06,0,0,1-.42-2.1c0-1,.9-2,2.7-3.29a15.79,15.79,0,0,1,10-3q6.15,0,15.59,6.23a8.52,8.52,0,0,0,6.82,1.43,8.65,8.65,0,0,0,5.65-3.79,9.36,9.36,0,0,0,1.1-6.82,8.66,8.66,0,0,0-3.8-5.65q-13.48-9.27-25.19-9.27a35.92,35.92,0,0,0-20.82,6.24q-9.95,7.57-9.94,18.54a20,20,0,0,0,2.86,10.61,26.24,26.24,0,0,0,10.71,9.27A62.32,62.32,0,0,0,708.88,153h.17q9.44,1.86,13.49,4.72a5.63,5.63,0,0,1,2.19,2,4.28,4.28,0,0,1,.5,2.45q0,1.77-3,4.3a21,21,0,0,1-11.46,3.2q-9.43.17-18.54-7.42a8.48,8.48,0,0,0-6.57-2,9.09,9.09,0,0,0-8,9.86,8.57,8.57,0,0,0,3.12,6q14.32,11.48,30,11.63A37.67,37.67,0,0,0,732.65,181q10.62-7.75,10.62-19.55A22.5,22.5,0,0,0,739.73,149.83Z"
                />
              </g>
            </g>
          </svg>
          <!-- Close button – mobile only -->
          <button class="sidebar-close-btn" (click)="closeSidebar()">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        <!-- "Dashboard" separate from accordion -->
        <div
          class="pl-6 pr-2 mt-5 flex cursor-pointer center-align"
          (click)="redirectTo($event, 'Dashboard')"
          role="button"
          tabindex="0"
          (keydown.enter)="redirectTo($any($event), 'Dashboard')"
          (keydown.space)="redirectTo($any($event), 'Dashboard')"
        >
          <span
            class="dashboard icon cursor"
            style="min-width: 24px; min-height: 24px"
          ></span>
          <span class="text-gray-300 hover:text-white cursor">{{
            t('Dashboard')
          }}</span>
        </div>

        @if (userRole === 'Manager') {
          <div
            class="pl-6 pr-2 mt-5 flex cursor-pointer center-align"
            (click)="redirectTo($event, 'Create organization')"
            role="button"
            tabindex="0"
            (keydown.enter)="redirectTo($any($event), 'Create organization')"
            (keydown.space)="redirectTo($any($event), 'Create organization')"
          >
            <span
              class="add-white-icon icon cursor"
              style="min-width: 24px; min-height: 24px"
            ></span>
            <span class="text-gray-300 hover:text-white cursor">{{
              t(tabLabelKey('Create organization'))
            }}</span>
          </div>

          <div
            class="pl-6 pr-2 mt-5 flex cursor-pointer center-align"
            (click)="redirectTo($event, 'Manager organizations')"
            role="button"
            tabindex="0"
            (keydown.enter)="redirectTo($any($event), 'Manager organizations')"
            (keydown.space)="redirectTo($any($event), 'Manager organizations')"
          >
            <span
              class="clinic-icon icon cursor"
              style="min-width: 24px; min-height: 24px"
            ></span>
            <span class="text-gray-300 hover:text-white cursor">{{
              t(tabLabelKey('Manager organizations'))
            }}</span>
          </div>

          <div
            class="pl-6 pr-2 mt-5 flex cursor-pointer center-align"
            (click)="redirectTo($event, 'Manager payouts')"
            role="button"
            tabindex="0"
            (keydown.enter)="redirectTo($any($event), 'Manager payouts')"
            (keydown.space)="redirectTo($any($event), 'Manager payouts')"
          >
            <span class="arrow-payment-history-white icon cursor" style="min-width: 24px; min-height: 24px"></span>
            <span class="text-gray-300 hover:text-white cursor">{{ t(tabLabelKey('Manager payouts')) }}</span>
          </div>

          <div
            class="pl-6 pr-2 mt-5 flex cursor-pointer center-align"
            (click)="redirectTo($event, 'Manager hierarchy')"
            role="button"
            tabindex="0"
            (keydown.enter)="redirectTo($any($event), 'Manager hierarchy')"
            (keydown.space)="redirectTo($any($event), 'Manager hierarchy')"
          >
            <span class="protocol-icon icon cursor" style="min-width: 24px; min-height: 24px"></span>
            <span class="text-gray-300 hover:text-white cursor">{{ t(tabLabelKey('Manager hierarchy')) }}</span>
          </div>

          <div
            class="pl-6 pr-2 mt-5 flex cursor-pointer center-align"
            (click)="redirectTo($event, 'Manager audit log')"
            role="button"
            tabindex="0"
            (keydown.enter)="redirectTo($any($event), 'Manager audit log')"
            (keydown.space)="redirectTo($any($event), 'Manager audit log')"
          >
            <span class="file-icon icon cursor" style="min-width: 24px; min-height: 24px"></span>
            <span class="text-gray-300 hover:text-white cursor">{{ t(tabLabelKey('Manager audit log')) }}</span>
          </div>

          <div
            class="pl-6 pr-2 mt-5 flex cursor-pointer center-align"
            (click)="redirectTo($event, 'At-risk contracts')"
            role="button"
            tabindex="0"
            (keydown.enter)="redirectTo($any($event), 'At-risk contracts')"
            (keydown.space)="redirectTo($any($event), 'At-risk contracts')"
          >
            <span
              class="notification-icon icon cursor"
              style="min-width: 24px; min-height: 24px"
            ></span>
            <span class="text-gray-300 hover:text-white cursor">{{
              t(tabLabelKey('At-risk contracts'))
            }}</span>
          </div>

          @if (store.canManageManagerSubordinates()) {
            <div
              class="pl-6 pr-2 mt-5 flex cursor-pointer center-align"
              (click)="redirectTo($event, 'Manager sub-managers')"
              role="button"
              tabindex="0"
              (keydown.enter)="redirectTo($any($event), 'Manager sub-managers')"
              (keydown.space)="redirectTo($any($event), 'Manager sub-managers')"
            >
              <span
                class="users-icon icon cursor"
                style="min-width: 24px; min-height: 24px"
              ></span>
              <span class="text-gray-300 hover:text-white cursor">{{
                t(tabLabelKey('Manager sub-managers'))
              }}</span>
            </div>
          }

          <div
            class="pl-6 pr-2 mt-5 flex cursor-pointer center-align"
            (click)="redirectTo($event, 'Manager notes')"
            role="button"
            tabindex="0"
            (keydown.enter)="redirectTo($any($event), 'Manager notes')"
            (keydown.space)="redirectTo($any($event), 'Manager notes')"
          >
            <span
              class="note-icon icon cursor"
              style="min-width: 24px; min-height: 24px"
            ></span>
            <span class="text-gray-300 hover:text-white cursor">{{
              t(tabLabelKey('Manager notes'))
            }}</span>
          </div>
        }

        @if (userRole === 'Clinic') {
          <div
            class="pl-6 pr-2 mt-5 flex cursor-pointer center-align"
            (click)="redirectTo($event, 'All Reports')"
            role="button"
            tabindex="0"
            (keydown.enter)="redirectTo($any($event), 'All Reports')"
            (keydown.space)="redirectTo($any($event), 'All Reports')"
          >
            <span
              class="my-reports-icon icon cursor"
              style="min-width: 24px; min-height: 24px"
            ></span>
            <span class="text-gray-300 hover:text-white cursor">{{
              t('All Reports')
            }}</span>
          </div>

          <div
            class="pl-6 pr-2 mt-5 flex cursor-pointer center-align"
            (click)="redirectTo($event, 'ClinicNotes')"
            role="button"
            tabindex="0"
            (keydown.enter)="redirectTo($any($event), 'ClinicNotes')"
            (keydown.space)="redirectTo($any($event), 'ClinicNotes')"
          >
            <span
              class="note-icon icon cursor"
              style="min-width: 24px; min-height: 24px"
            ></span>
            <span class="text-gray-300 hover:text-white cursor">{{
              t('Notes')
            }}</span>
          </div>
        }

        @if (userRole === 'ClinicOwner') {
          <div
            class="pl-6 pr-2 mt-5 flex cursor-pointer center-align"
            (click)="redirectTo($event, 'Ambulances')"
            role="button"
            tabindex="0"
            (keydown.enter)="redirectTo($any($event), 'Ambulances')"
            (keydown.space)="redirectTo($any($event), 'Ambulances')"
          >
            <span
              class="clinic-icon icon cursor"
              style="min-width: 24px; min-height: 24px"
            ></span>
            <span class="text-gray-300 hover:text-white cursor">{{
              t('Ambulances')
            }}</span>
          </div>

          <div
            class="pl-6 pr-2 mt-5 flex cursor-pointer center-align"
            (click)="redirectTo($event, 'Veterinarians')"
            role="button"
            tabindex="0"
            (keydown.enter)="redirectTo($any($event), 'Veterinarians')"
            (keydown.space)="redirectTo($any($event), 'Veterinarians')"
          >
            <span
              class="user-icon icon cursor"
              style="min-width: 24px; min-height: 24px"
            ></span>
            <span class="text-gray-300 hover:text-white cursor">{{
              t('Veterinarians')
            }}</span>
          </div>

          @if (store.debt()?.debt) {
            <div
              class="pl-6 pr-2 mt-5 flex cursor-pointer center-align"
              (click)="redirectTo($event, 'Debts')"
              role="button"
              tabindex="0"
              (keydown.enter)="redirectTo($any($event), 'Debts')"
              (keydown.space)="redirectTo($any($event), 'Debts')"
            >
              <span
                class="my-reports-icon icon cursor"
                style="min-width: 24px; min-height: 24px"
              ></span>
              <span class="text-gray-300 hover:text-white cursor">{{
                t('Debts')
              }}</span>
            </div>
          }

          <div
            class="pl-6 pr-2 mt-5 flex cursor-pointer center-align"
            (click)="redirectTo($event, 'OwnerNotes')"
            role="button"
            tabindex="0"
            (keydown.enter)="redirectTo($any($event), 'OwnerNotes')"
            (keydown.space)="redirectTo($any($event), 'OwnerNotes')"
          >
            <span
              class="note-icon icon cursor"
              style="min-width: 24px; min-height: 24px"
            ></span>
            <span class="text-gray-300 hover:text-white cursor">{{
              t('Notes')
            }}</span>
          </div>
        }

        @if (userRole === 'Administrator') {
          <!-- Angular Material Accordion for Administrator dropdowns -->
          <mat-accordion class="admin-nav-accordion flex-1 pl-2 pr-2 mt-5">
            <mat-expansion-panel [expanded]="false">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span
                    class="users-icon icon padding-xs cursor"
                    style="min-width: 24px; min-height: 24px"
                  ></span>
                  {{ t('Managers') }}
                </mat-panel-title>
              </mat-expansion-panel-header>

              <a
                (click)="redirectTo($event, 'Managers')"
                class="admin-nav-link text-gray-300 hover:primary-color hover:text-white flex items-center rounded-md px-2 py-2 text-sm font-medium"
              >
                <span
                  class="users-icon icon padding-xs cursor"
                  style="min-width: 24px; min-height: 24px"
                ></span>
                <span class="cursor">{{ t('Managers') }}</span>
              </a>

              <a
                (click)="redirectTo($event, 'Managers to pay')"
                class="admin-nav-link text-gray-300 hover:primary-color hover:text-white flex items-center rounded-md px-2 py-2 text-sm font-medium"
              >
                <span
                  class="users-icon icon padding-xs cursor"
                  style="min-width: 24px; min-height: 24px"
                ></span>
                <span class="cursor">{{ t('Managers to pay') }}</span>
              </a>

              <a
                (click)="redirectTo($event, 'Unassigned contracts')"
                class="admin-nav-link text-gray-300 hover:primary-color hover:text-white flex items-center rounded-md px-2 py-2 text-sm font-medium"
              >
                <span
                  class="users-icon icon padding-xs cursor"
                  style="min-width: 24px; min-height: 24px"
                ></span>
                <span class="cursor">{{ t('Unassigned contracts') }}</span>
              </a>
            </mat-expansion-panel>

            <mat-expansion-panel [expanded]="false">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span
                    class="clinic-icon icon padding-xs cursor"
                    style="min-width: 24px; min-height: 24px"
                  ></span>
                  {{ t('Contracts') }}
                </mat-panel-title>
              </mat-expansion-panel-header>

              <a
                (click)="redirectTo($event, 'Clinics')"
                class="admin-nav-link text-gray-300 hover:primary-color hover:text-white flex items-center rounded-md px-2 py-2 text-sm font-medium"
              >
                <span
                  class="clinic-icon icon padding-xs cursor"
                  style="min-width: 24px; min-height: 24px"
                ></span>
                <span class="cursor">{{ t('Clinics') }}</span>
              </a>

              <a
                (click)="redirectTo($event, 'Hotels')"
                class="admin-nav-link text-gray-300 hover:primary-color hover:text-white flex items-center rounded-md px-2 py-2 text-sm font-medium"
              >
                <span
                  class="hotel-icon icon padding-xs cursor"
                  style="min-width: 24px; min-height: 24px"
                ></span>
                <span class="cursor">{{ t('Hotels') }}</span>
              </a>

              <a
                (click)="redirectTo($event, 'Others')"
                class="admin-nav-link text-gray-300 hover:primary-color hover:text-white flex items-center rounded-md px-2 py-2 text-sm font-medium"
              >
                <span
                  class="other-icon icon padding-xs cursor"
                  style="min-width: 24px; min-height: 24px"
                ></span>
                <span class="cursor">{{ t('Others') }}</span>
              </a>

              <a
                (click)="redirectTo($event, 'Walkers')"
                class="admin-nav-link text-gray-300 hover:primary-color hover:text-white flex items-center rounded-md px-2 py-2 text-sm font-medium"
              >
                <span
                  class="walk-icon icon padding-xs cursor"
                  style="min-width: 24px; min-height: 24px"
                ></span>
                <span class="cursor">{{ t('Walkers') }}</span>
              </a>

              <a
                (click)="redirectTo($event, 'Trainers')"
                class="admin-nav-link text-gray-300 hover:primary-color hover:text-white flex items-center rounded-md px-2 py-2 text-sm font-medium"
              >
                <span
                  class="users-icon icon padding-xs cursor"
                  style="min-width: 24px; min-height: 24px"
                ></span>
                <span class="cursor">{{ t('Trainers') }}</span>
              </a>

              <a
                (click)="redirectTo($event, 'Groomers')"
                class="admin-nav-link text-gray-300 hover:primary-color hover:text-white flex items-center rounded-md px-2 py-2 text-sm font-medium"
              >
                <span
                  class="scissors-icon icon padding-xs cursor"
                  style="min-width: 24px; min-height: 24px"
                ></span>
                <span class="cursor">{{ t('Groomers') }}</span>
              </a>

              <a
                (click)="redirectTo($event, 'Pet Transporters')"
                class="admin-nav-link text-gray-300 hover:primary-color hover:text-white flex items-center rounded-md px-2 py-2 text-sm font-medium"
              >
                <span
                  class="car-icon icon padding-xs cursor"
                  style="min-width: 24px; min-height: 24px"
                ></span>
                <span class="cursor">{{ t('Pet Transporters') }}</span>
              </a>

              <a
                (click)="redirectTo($event, 'Stores')"
                class="admin-nav-link text-gray-300 hover:primary-color hover:text-white flex items-center rounded-md px-2 py-2 text-sm font-medium"
              >
                <span
                  class="stores-icon icon padding-xs cursor"
                  style="min-width: 24px; min-height: 24px"
                ></span>
                <span class="cursor">{{ t('Stores') }}</span>
              </a>

              <a
                (click)="redirectTo($event, 'Pet Insurances')"
                class="admin-nav-link text-gray-300 hover:primary-color hover:text-white flex items-center rounded-md px-2 py-2 text-sm font-medium"
              >
                <span
                  class="pet-insurance-icon icon padding-xs cursor"
                  style="min-width: 24px; min-height: 24px"
                ></span>
                <span class="cursor">{{ t('Pet Insurances') }}</span>
              </a>

              <a
                (click)="redirectTo($event, 'Promotions')"
                class="admin-nav-link text-gray-300 hover:primary-color hover:text-white flex items-center rounded-md px-2 py-2 text-sm font-medium"
              >
                <span
                  class="promotions-icon icon padding-xs cursor"
                  style="min-width: 24px; min-height: 24px"
                ></span>
                <span class="cursor">{{ t('Promotions') }}</span>
              </a>
            </mat-expansion-panel>

            <mat-expansion-panel [expanded]="false">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span
                    class="book-icon icon padding-xs cursor"
                    style="min-width: 24px; min-height: 24px"
                  ></span>
                  {{ t('Blogs') }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <a
                (click)="redirectTo($event, 'Interesting')"
                class="text-gray-300 hover:primary-color hover:text-white flex items-center rounded-md px-2 py-2 text-sm font-medium"
              >
                <span
                  class="interesting-icon icon padding-xs cursor"
                  style="min-width: 24px; min-height: 24px"
                ></span>
                <span class="cursor">{{ t('Interesting') }}</span>
              </a>

              <a
                (click)="redirectTo($event, 'Tips')"
                class="text-gray-300 hover:primary-color hover:text-white flex items-center rounded-md px-2 py-2 text-sm font-medium"
              >
                <span
                  class="interesting-icon icon padding-xs cursor"
                  style="min-width: 24px; min-height: 24px"
                ></span>
                <span class="cursor">{{ t('Tips') }}</span>
              </a>

              <a
                (click)="redirectTo($event, 'Events')"
                class="text-gray-300 hover:primary-color hover:text-white flex items-center rounded-md px-2 py-2 text-sm font-medium"
              >
                <span
                  class="calendar-white-icon icon padding-xs cursor"
                  style="min-width: 24px; min-height: 24px"
                ></span>
                <span class="cursor">{{ t('Events') }}</span>
              </a>

              <a
                (click)="redirectTo($event, 'Forum-Topics')"
                class="text-gray-300 hover:primary-color hover:text-white flex items-center rounded-md px-2 py-2 text-sm font-medium"
              >
                <span
                  class="interesting-icon icon padding-xs cursor"
                  style="min-width: 24px; min-height: 24px"
                ></span>
                <span class="cursor">{{
                  t('portal.forumModeration.tab')
                }}</span>
              </a>

              <!-- <a

              <a
                (click)="redirectTo($event, 'Nutrition')"
                class="text-gray-300 hover:primary-color hover:text-white flex items-center rounded-md px-2 py-2 text-sm font-medium"
              >
                <span
                  class="nutrition-icon icon padding-xs cursor"
                  style="min-width: 24px; min-height: 24px"
                ></span>
                <span class="cursor">{{ t('Nutrition') }}</span>
              </a>

              <a
                (click)="redirectTo($event, 'First Aid')"
                class="text-gray-300 hover:primary-color hover:text-white flex items-center rounded-md px-2 py-2 text-sm font-medium"
              >
                <span
                  class="first-aid-icon icon padding-xs cursor"
                  style="min-width: 24px; min-height: 24px"
                ></span>
                <span class="cursor">{{ t('First Aid') }}</span>
              </a>

              <a
                (click)="redirectTo($event, 'News')"
                class="text-gray-300 hover:primary-color hover:text-white flex items-center rounded-md px-2 py-2 text-sm font-medium"
              >
                <span
                  class="newspaper-icon icon padding-xs cursor"
                  style="min-width: 24px; min-height: 24px"
                ></span>
                <span class="cursor">{{ t('News') }}</span>
              </a> -->
            </mat-expansion-panel>

            <!-- Sistemska podešavanja dropdown -->
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span
                    class="settings-icon icon padding-xs cursor"
                    style="min-width: 24px; min-height: 24px"
                  ></span>
                  {{ t('Systems') }}
                </mat-panel-title>
              </mat-expansion-panel-header>

              <a
                (click)="redirectTo($event, 'Breeds')"
                class="text-gray-300 hover:primary-color hover:text-white flex items-center rounded-md px-2 py-2 text-sm font-medium"
              >
                <span
                  class="dog-icon icon padding-xs cursor"
                  style="min-width: 24px; min-height: 24px"
                ></span>
                <span class="cursor">{{ t('Breeds') }}</span>
              </a>

              <a
                (click)="redirectTo($event, 'System-Diagnoses')"
                class="text-gray-300 hover:primary-color hover:text-white flex items-center rounded-md px-2 py-2 text-sm font-medium"
              >
                <span
                  class="types-diagnoses-icon icon padding-xs cursor"
                  style="min-width: 24px; min-height: 24px"
                ></span>
                <span class="cursor">{{ t('System Diagnoses') }}</span>
              </a>

              <a
                (click)="redirectTo($event, 'System-Services')"
                class="text-gray-300 hover:primary-color hover:text-white flex items-center rounded-md px-2 py-2 text-sm font-medium"
              >
                <span
                  class="type-services-icon icon padding-xs cursor"
                  style="min-width: 24px; min-height: 24px"
                ></span>
                <span class="cursor">{{ t('System Services') }}</span>
              </a>

              <a
                (click)="redirectTo($event, 'System-Type-Medicaments')"
                class="text-gray-300 hover:primary-color hover:text-white flex items-center rounded-md px-2 py-2 text-sm font-medium"
              >
                <span
                  class="type-medicaments-icon icon padding-xs cursor"
                  style="min-width: 24px; min-height: 24px"
                ></span>
                <span class="cursor">{{ t('Type Medicaments') }}</span>
              </a>

              <a
                (click)="redirectTo($event, 'System-Notifications')"
                class="text-gray-300 hover:primary-color hover:text-white flex items-center rounded-md px-2 py-2 text-sm font-medium"
              >
                <span
                  class="notification-icon icon padding-xs cursor"
                  style="min-width: 24px; min-height: 24px"
                ></span>
                <span class="cursor">{{ t('System Notifications') }}</span>
              </a>

              <a
                (click)="redirectTo($event, 'Legal-Documents')"
                class="text-gray-300 hover:primary-color hover:text-white flex items-center rounded-md px-2 py-2 text-sm font-medium"
              >
                <span
                  class="file-icon icon padding-xs cursor"
                  style="min-width: 24px; min-height: 24px"
                ></span>
                <span class="cursor">{{ t('Legal Documents') }}</span>
              </a>

              <a
                (click)="redirectTo($event, 'Video-Tutorials')"
                class="text-gray-300 hover:primary-color hover:text-white flex items-center rounded-md px-2 py-2 text-sm font-medium"
              >
                <span
                  class="book-icon icon padding-xs cursor"
                  style="min-width: 24px; min-height: 24px"
                ></span>
                <span class="cursor">{{ t('Video Tutorials') }}</span>
              </a>

              <a
                (click)="redirectTo($event, 'Subscription-Plans')"
                class="text-gray-300 hover:primary-color hover:text-white flex items-center rounded-md px-2 py-2 text-sm font-medium"
              >
                <span
                  class="type-services-icon icon padding-xs cursor"
                  style="min-width: 24px; min-height: 24px"
                ></span>
                <span class="cursor">{{ t('Subscription Plans') }}</span>
              </a>
            </mat-expansion-panel>
          </mat-accordion>
        }

        <!-- Angular Material Accordion for dropdowns -->
        @if (userRole !== 'Manager' && filteredCategoryTree.length) {
        <mat-accordion class="mt-5 flex-1 space-y-1 pl-6 pr-2">
          <!-- Loop through categories -->

          @for (
            category of filteredCategoryTree;
            track category;
            let i = $index
          ) {
            <mat-expansion-panel [expanded]="isPanelOpen(i)">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span
                    [ngClass]="[category.icon, 'icon', 'padding-xs', 'cursor']"
                    style="min-width: 24px; min-height: 24px"
                  ></span>
                  {{ t(category.name) }}
                </mat-panel-title>
              </mat-expansion-panel-header>

              <!-- Sub-items (children) -->

              @for (child of category.children; track child) {
                <ng-container style="border-left: 1px solid white">
                  <a
                    (click)="redirectTo($event, child.name)"
                    class="text-gray-300 hover:primary-color hover:text-white flex items-center rounded-md px-2 py-2 text-sm font-medium"
                  >
                    <span
                      [ngClass]="[child.icon, 'icon', 'padding-xs', 'cursor']"
                      style="min-width: 24px; min-height: 24px"
                    ></span>
                    <span class="cursor">{{ t(child.name) }}</span>
                  </a>
                </ng-container>
              }
            </mat-expansion-panel>
          }
        </mat-accordion>
        }
      </div>
      <div
        class="border-top-sidebar gap-5 flex-col text-gray-300 hover:primary-color hover:text-white flex items-start px-2 py-2 text-sm font-medium"
      >
        <!-- <div class="px-2 flex" (click)="redirectTo($event, 'Knowledge Base')" role="button" tabindex="0" (keydown.enter)="redirectTo($any($event), 'Knowledge Base')" (keydown.space)="redirectTo($any($event), 'Knowledge Base')">
            <span class="book-open-icon icon padding-xs cursor"></span>
            <span
              class="text-gray-300 hover:text-white secondary-color cursor"
              >{{ t('Knowledge Base') }}</span
            >
          </div> -->
        @if (userRole === 'Clinic' || userRole === 'ClinicOwner' || userRole === 'Manager') {
          <div
            class="px-2 flex cursor-pointer center-align"
            (click)="redirectTo($event, 'Video-Tutorials')"
            role="button"
            tabindex="0"
            (keydown.enter)="redirectTo($any($event), 'Video-Tutorials')"
            (keydown.space)="redirectTo($any($event), 'Video-Tutorials')"
          >
            <span
              class="book-icon icon padding-xs cursor"
              style="min-width: 24px; min-height: 24px"
            ></span>
            <span
              class="text-gray-300 hover:text-white secondary-color cursor-pointer center-align"
              >{{ t('Video Tutorials') }}</span
            >
          </div>
        }
        <div
          class="px-2 flex cursor-pointer center-align"
          (click)="redirectTo($event, 'Support')"
          role="button"
          tabindex="0"
          (keydown.enter)="redirectTo($any($event), 'Support')"
          (keydown.space)="redirectTo($any($event), 'Support')"
        >
          <span
            class="help-shell-icon icon padding-xs cursor"
            style="min-width: 24px; min-height: 24px"
          ></span>
          <span
            class="text-gray-300 hover:text-white secondary-color cursor-pointer center-align"
            >{{ t('Support') }}</span
          >
        </div>
        <div
          class="px-2 flex cursor-pointer center-align settings-link"
          (click)="redirectToSettings($event)"
          role="button"
          tabindex="0"
          (keydown.enter)="redirectToSettings($any($event))"
          (keydown.space)="redirectToSettings($any($event))"
        >
          <span class="settings-icon-wrap">
            <span class="settings-icon icon padding-xs cursor"></span>
            @if (
              (userRole === 'Clinic' || userRole === 'ClinicOwner') &&
              premiumBadge.unpaidCount() > 0
            ) {
              <span class="settings-unpaid-badge">{{
                premiumBadge.unpaidCount()
              }}</span>
            }
          </span>
          <span
            class="text-gray-300 hover:text-white secondary-color cursor-pointer center-align"
            >{{ t('Settings') }}</span
          >
        </div>
        <div
          class="px-2 flex cursor-pointer center-align"
          (click)="logOut($event)"
          role="button"
          tabindex="0"
          (keydown.enter)="logOut($any($event))"
          (keydown.space)="logOut($any($event))"
        >
          <span class="logout-icon icon padding-xs cursor"></span>
          <span class="text-gray-300 hover:text-white secondary-color cursor">{{
            t('Log out')
          }}</span>
        </div>
      </div>
    </div>
  </div>

  @if (isLoggingOut()) {
    <div class="logout-overlay">
      <mat-progress-spinner
        diameter="48"
        mode="indeterminate"
        strokeWidth="4"
      ></mat-progress-spinner>
    </div>
  }

  <!-- Main Content: margin-left ensures it stays next to the sidebar -->
  <div class="main-content flex flex-1 flex-col">
    <main class="flex-1">
      <anihis-navigation #navigation></anihis-navigation>
    </main>
  </div>
</ng-container>
